import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController, ToastController } from 'ionic-angular';

/**
 * Generated class for the AssessmentCompletePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage({
  name: 'assessment-complete',
  segment: 'assessment-complete',
  //priority: 'high'
})
@Component({
  selector: 'page-assessment-complete',
  templateUrl: 'assessment-complete.html',
})
export class AssessmentCompletePage {

  assessmentCompleted: boolean;
  isSchedule: boolean;
  clientId: string;
  isEmailResultToClient: string
  text: string
  reportsArray : Array<{report_url : string , assessmentName : string}> = [];

  constructor(public navCtrl: NavController, public navParams: NavParams,public alertCtrl: AlertController,public toastCtrl: ToastController) {
  
  }

  ionViewDidLoad() {
    this.assessmentCompleted = this.navParams.get('assessmentCompleted');
    this.clientId = this.navParams.get('clientId')
    if(this.navParams.get('isSchedule')){
      this.isSchedule = this.navParams.get('isSchedule');
      this.isEmailResultToClient = this.navParams.get('isEmailResultToClient')
      this.reportsArray = this.navParams.get('reports')
      if(this.isEmailResultToClient == "1"){
        this.text = "To view the results click below"
      }else {
        this.text = "You can now close this page"
      }
    }
    
  }

  viewReport(item:any){
    if (item.report_url) {
      var popup = window.open('', "_blank");
          popup.location.href = item.report_url
    }
  }

  cancel() {
    let prompt = this.alertCtrl.create({
      title: 'Enter Password',
      message: "Please enter the password to exit assessment",
      inputs: [
        {
          name: 'password',
          placeholder: 'password',
          type: 'password'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'Exit',
          handler: data => {
            if (data.password === localStorage.getItem('password')) {
              this.navCtrl.push('clients', { clientId: this.clientId });
            } else {
              let toast = this.toastCtrl.create({
                message: 'The password is incorrect',
                duration: 3000,
                position: 'top'
              });
              toast.present();
            }

          }
        }
      ]
    });
    prompt.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/assessment-complete/assessment-complete.ts